import timeFieldPreferencesFragment from '@data/fragments/preferences/timeFieldPreferencesFragment'
import updateAddressFragment from '@data/fragments/preferences/updateAddressFragment'
import gql from 'graphql-tag'

export default gql`
  fragment checkoutDeliveryPreferences on Preference {
    _id
    websiteId
    deliveryType
    tableName
    timeLabel
    time
    placeId
    itsStoreOpenAtTime
    dropOffType
    itsStoreOpenAtTime
    directions {
      duration
    }
    website {
      _id
      name
    }
    address {
      _id
      placeId
      address
      addressSecondary
      addressLine2
      acceptsNoLine2
      location
      comment
    }
    store {
      _id
      name
      schedule {
        itsOpenNow: itsAvailableAt
      }
      acceptServeSchedulingOrders
      schedulingOrdersDays
      currentPreparationDuration
      currentExtraDeliveryCost
      currentDeliveryDuration
      isOverloaded
      address {
        address
        addressLine2
      }
    }
    ...timeFieldPreferences
    ...updateAddressFragment
  }
  ${timeFieldPreferencesFragment}
  ${updateAddressFragment}
`
